module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/152/assets/images/b7e0fcadf0c8d86d0946fbee80abc4c3.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_group_arrow.svg
// module id = jXno
// module chunks = 1